import { getElementOfType } from "../utils/dom.js";
import { PlayerActions } from "../player/player-actions.js";
import { ReactiveElement } from "@nrk/reactive-element";
class KeyboardElement extends ReactiveElement {
  /** The PlayerElement parent instance */
  player;
  value;
  readyCallback() {
    this.player = getElementOfType(this);
    document.addEventListener("keydown", this);
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this);
    this.player = null;
    super.disconnectedCallback();
  }
  handleEvent(event) {
    if (!this.player.focusWithin || event.defaultPrevented) {
      return;
    }
    const key = event.key;
    const metaKey = event.metaKey || event.ctrlKey || event.altKey || event.shiftKey;
    const target = event.target;
    switch (key) {
      case "ArrowLeft": {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(
            PlayerActions.SeekToRelativeTime,
            metaKey ? -this.player.seekableStep * 4 : -this.player.seekableStep
          );
        }
        break;
      }
      case "ArrowRight": {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(
            PlayerActions.SeekToRelativeTime,
            metaKey ? this.player.seekableStep * 4 : this.player.seekableStep
          );
        }
        break;
      }
    }
    if (metaKey) {
      return;
    }
    switch (key) {
      case "Enter":
      case "SpaceBar":
      case " ": {
        if (target?.nodeName !== "BUTTON") {
          event.preventDefault();
          this.emit(PlayerActions.TogglePlay);
        }
        break;
      }
      case "k": {
        event.preventDefault();
        this.emit(PlayerActions.TogglePlay);
        break;
      }
      case "j": {
        event.preventDefault();
        this.emit(PlayerActions.SeekToRelativeTime, -this.player.seekableStep);
        break;
      }
      case "l": {
        event.preventDefault();
        this.emit(PlayerActions.SeekToRelativeTime, this.player.seekableStep);
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9": {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, (this.keyToCode(key) - 48) / 10);
        break;
      }
      case "Home": {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, 0);
        break;
      }
      case "End": {
        event.preventDefault();
        this.emit(PlayerActions.SeekToPosition, 1);
        break;
      }
      case "ArrowUp": {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          console.log("dispatch for volume up", this.player.volume);
          this.emit(PlayerActions.SetVolume, this.player.volume * 100 + 10);
        }
        break;
      }
      case "ArrowDown": {
        if (!target || target.nodeName !== "INPUT") {
          event.preventDefault();
          this.emit(PlayerActions.SetVolume, this.player.volume * 100 - 10);
        }
        break;
      }
      case "f": {
        if (this.player.fullscreenState?.isActive) {
          this.emit(PlayerActions.ExitFullscreen);
        } else {
          this.emit(PlayerActions.EnterFullscreen);
        }
        break;
      }
      case "m": {
        event.preventDefault();
        this.emit(PlayerActions.ToggleMute);
        break;
      }
      case "c": {
        break;
      }
      case "p": {
        event.preventDefault();
        if (this.player.pipState?.isActive) {
          this.emit(PlayerActions.ExitPip);
        } else {
          this.emit(PlayerActions.EnterPip);
        }
        break;
      }
      case "a":
      case "z": {
        break;
      }
    }
  }
  keyToCode(key) {
    return key.charCodeAt(0);
  }
  emit(action, value) {
    this.value = value;
    this.setAttribute("action", action);
    this.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
export {
  KeyboardElement
};
